// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Script } from 'vm';

Vue.config.productionTip = false

Vue.prototype.$appName = process.env.BASE_URL
Vue.prototype.$hostname = process.env.API_URL
Vue.prototype.$session_Expire_in = process.env.SESSION_TIMEOUT_IN
Vue.prototype.$ipohostname = process.env.IPO_API_URL
Vue.prototype.$intPlatform_url = process.env.INT_PLATFORM_URL
Vue.prototype.$intPlatform_key = "AWT-=y2xZt94QPae-?R+.P-nzL6@+4\\e4f5b+N[5#$lWJ#7JyAYfhH~RrN]Q"      /* process.env.INT_PLATFORM_KEY */

Vue.prototype.$microservice_url = process.env.MICROSERVICE_URL
Vue.prototype.$microservice_intui_url = process.env.MICROSERVICE_INTUI_URL

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




  







// WEBPACK FOOTER //
// ./src/main.js